import React, { useEffect, useState } from "react";
import Footer from "../Header/Footer";
import Header from "../Header/Header";
import Config from "../Header/Config";

import { FaEdit, FaTrashAlt, FaFileExcel, FaFilePdf } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { exportFilteredToExcel } from "../../utils/excelExport";
import { exportFilteredToPDF } from "../../utils/pdfExport";
const ITEMS_PER_PAGE = 500; // Number of items to display per page

export default function Sale_BuyBack_Table() {
  const apiUrl = Config.apiUrl;
  const [isLoading, setIsLoading] = useState(true);
  // ........................................................................[ fetch All Buyback details ]................................

  const [brand, setBrand] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${apiUrl}/get_all_returnBrand`);
        const data = await response.json();
        setBrand(data.data || []);
        setIsLoading(false);
        console.log(data);
      } catch (error) {
        console.error(error);
        setIsLoading(false);
      }
    };
    fetchData();
  }, []);

  //........................................
  const handleDelete = (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this record?"
    );

    if (confirmDelete) {
      fetch(`${apiUrl}/delete_returnBrand/${id}`, {
        method: "DELETE",
      })
        .then((response) => response.json())
        .then(() => {
          window.location.reload();
        })
        .catch((error) => {
          console.error("Error deleting data:", error);
        });
    }
  };

  //........................................[ navigate to purchase page using invoice no]................................

  const navigate = useNavigate();
  const handleView = async (id, event) => {
    event.stopPropagation();
    const invoice = id;
    navigate(`/sale_update?invoice_no=${invoice}`);
  };

  //......................................................................................................
  //.....................................[ Search box ]...............................................
  const [searchQuery, setSearchQuery] = useState(""); // State variable for the search query
  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
    setCurrentPage(1);
  };

  const filteredTableData = brand.filter((row) => {
    const customerName = row.customer_name
      ? row.customer_name.toLowerCase()
      : "";
    const modelName = row.model_name ? row.model_name.toLowerCase() : "";
    const date = row.date ? row.date.toString() : "";
    const imei = row.imei ? row.imei.toString() : "";
    const price = row.price ? row.price.toString() : "";

    return (
      customerName.includes(searchQuery.toLowerCase()) ||
      modelName.includes(searchQuery.toLowerCase()) ||
      date.includes(searchQuery.toString()) ||
      imei.includes(searchQuery.toString()) ||
      price.includes(searchQuery.toString())
    );
  });

  //..................................[ Pagination ].........................................

  const [currentPage, setCurrentPage] = useState(1);

  // Calculate the total number of pages based on the data and items per page
  const totalPages = Math.ceil(filteredTableData.length / ITEMS_PER_PAGE);

  // Calculate the index range for the items to be displayed on the current page
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const endIndex = Math.min(
    startIndex + ITEMS_PER_PAGE,
    filteredTableData.length
  );

  // Function to handle pagination button clicks
  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  // Excel Export Handler
  const handleExportToExcel = () => {
    const columns = [
      { key: 'customer_name', label: 'Customer Name' },
      { key: 'date', label: 'Date' },
      { key: 'model_name', label: 'Model Name' },
      { key: 'color', label: 'Color' },
      { key: 'imei', label: 'IMEI' },
      { key: 'price', label: 'Price' },
    ];
    exportFilteredToExcel(filteredTableData, columns, 'BuyBackList');
  };

  // PDF Export Handler
  const handleExportToPDF = () => {
    const columns = [
      { key: 'customer_name', label: 'Customer Name' },
      { key: 'date', label: 'Date' },
      { key: 'model_name', label: 'Model Name' },
      { key: 'color', label: 'Color' },
      { key: 'imei', label: 'IMEI' },
      { key: 'price', label: 'Price' },
    ];
    exportFilteredToPDF(filteredTableData, columns, 'BuyBackList');
  };

  return (
    <>
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />

          <div className="layout-page">
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <h4 className="fw-bold py-3 mb-4">Buy Back List</h4>

                <hr className="my-5" />
                {/* Search Box and Export Button */}
                <div style={{ display: "flex", justifyContent: "end", gap: "10px", alignItems: "center" }}>
                  <div className="mb-3 col-md-3">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search..."
                      value={searchQuery}
                      onChange={handleSearch}
                    />
                  </div>
                  {/* <div className="mb-3">
                    <button
                      className="btn btn-success"
                      onClick={handleExportToExcel}
                      disabled={!filteredTableData || filteredTableData.length === 0}
                      title="Export to Excel"
                      style={{ display: "flex", alignItems: "center", gap: "5px" }}
                    >
                      <FaFileExcel />
                      Export Excel
                    </button>
                  </div> */}
                  <div className="mb-3">
                    <button
                      className="btn btn-danger"
                      onClick={handleExportToPDF}
                      disabled={!filteredTableData || filteredTableData.length === 0}
                      title="Export to PDF"
                      style={{ display: "flex", alignItems: "center", gap: "5px" }}
                    >
                      <FaFilePdf />
                      Export PDF
                    </button>
                  </div>
                </div>

                <div className="card">
                  <h5 className="card-header">Buy Back List</h5>
                  <div
                    className="table-responsive text-nowrap"
                    style={{ overflowY: "auto", maxHeight: "600px" }}
                  >
                    {isLoading ? (
                      <div className="d-flex justify-content-center mb-5">
                        <div
                          className="spinner-border text-primary"
                          role="status"
                        >
                          <span className="sr-only "></span>
                        </div>
                      </div>
                    ) : (
                      <table className="table">
                        <thead
                          style={{
                            position: "sticky",
                            top: 0,
                            zIndex: 1,
                            backgroundColor: "#f5f5f5",
                          }}
                        >
                          <tr className="text-nowrap">
                            <th>SN</th>
                            <th>Customer Name</th>
                            <th>Date</th>

                            <th>Model Name</th>
                            <th>Color</th>
                            <th>IMEI</th>
                            <th>Price</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {Array.isArray(filteredTableData) && filteredTableData.length > 0 ? (
                            filteredTableData
                              .slice(startIndex, endIndex)
                              .map((row, index) => {
                                const originalIndex = brand.findIndex(item => item.id === row.id);
                                return (
                                <tr key={index}>
                                  <td>{originalIndex !== -1 ? originalIndex + 1 : index + 1}</td>
                                  <td>{row.customer_name}</td>
                                  <td>{row.date}</td>

                                  <td>{row.model_name}</td>
                                  <td>{row.color}</td>
                                  <td>{row.imei}</td>
                                  <td>{row.price}</td>
                                  <td>
                                    <button
                                      type="submit"
                                      className="btn btnn"
                                      style={{
                                        padding: "0px",
                                        marginLeft: "2px",
                                        marginRight: "2px",
                                        backgroundColor: "transparent", // Set background color to transparent
                                        color: "white", // Set text color to white
                                        border: "1px solid #fff", // Add a border for better visibility
                                      }}
                                      onClick={(event) =>
                                        handleView(row.invoice_no, event)
                                      }
                                    >
                                      <FaEdit className="icon_color"></FaEdit>
                                    </button>
                                    <button
                                    style={{
                                      padding: "0px",
                                      marginLeft: "2px",
                                      marginRight: "2px",
                                      backgroundColor: "transparent", // Set background color to transparent
                                      color: "white", // Set text color to white
                                      border: "1px solid #fff", // Add a border for better visibility
                                    }}
                                      type="submit"
                                      className="btn btnn"
                                      onClick={(event) =>
                                        handleDelete(row.id, event)
                                      }
                                    >
                                      <FaTrashAlt className="icon_color" />
                                    </button>
                                  </td>
                                </tr>
                                );
                              })
                          ) : (
                            <tr>
                              <td colSpan="6">No data available</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    )}
                  </div>
                </div>
                {/* Pagination */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "end",
                    padding: "10px 10px",
                  }}
                >
                  <nav aria-label="Page navigation">
                    <ul className="pagination">
                      {/* Previous arrow button */}
                      <li
                        className={`page-item ${currentPage === 1 ? "disabled" : ""
                          }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(currentPage - 1)}
                          disabled={currentPage === 1}
                        >
                          {"<"}
                        </button>
                      </li>

                      {/* Page numbers */}
                      {Array.from(
                        { length: totalPages },
                        (_, index) => index + 1
                      ).map(
                        (pageNumber) =>
                          // Render the page number button only if it's within the range of visible pages
                          pageNumber >= currentPage - 2 &&
                          pageNumber <= currentPage + 2 && (
                            <li
                              key={pageNumber}
                              className={`page-item ${pageNumber === currentPage ? "active" : ""
                                }`}
                            >
                              <button
                                className="page-link"
                                onClick={() => handlePageChange(pageNumber)}
                              >
                                {pageNumber}
                              </button>
                            </li>
                          )
                      )}

                      {/* Next arrow button */}
                      <li
                        className={`page-item ${currentPage === totalPages ? "disabled" : ""
                          }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(currentPage + 1)}
                          disabled={currentPage === totalPages}
                        >
                          {">"}
                        </button>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>

              <Footer />

              <div className="content-backdrop fade" />
            </div>
          </div>
        </div>

        <div className="layout-overlay layout-menu-toggle" />
      </div>
    </>
  );
}
